/** Copy for real QR verification; storyboard copy remains separate. */
export const TICKET_SCAN_STRINGS: Record<string, [string, string, string]> = {
  'ts.progress.notFoundContext': [
    '退票進度 · 查無申請',
    'Refund progress · No request found',
    '払い戻し状況 · 申請なし',
  ],
  'ts.progress.failedContext': [
    '退票進度 · 退款失敗',
    'Refund progress · Refund failed',
    '払い戻し状況 · 返金失敗',
  ],
  'ts.progress.manualContext': [
    '退票進度 · 需要人員協助',
    'Refund progress · Staff assistance',
    '払い戻し状況 · スタッフ対応',
  ],
  'ts.progress.completeContext': [
    '退票進度 · 全部完成',
    'Refund progress · Completed',
    '払い戻し状況 · 完了',
  ],
  'ts.progress.allowanceContext': [
    '退票進度 · 發票折讓處理中',
    'Refund progress · Invoice adjustment',
    '払い戻し状況 · 請求書調整',
  ],
  'ts.progress.allowanceNote': [
    '退款流程已進入發票折讓階段，尚未全部完成。實際入帳時間請向付款機構確認。',
    'The refund workflow has reached invoice adjustment and is not yet complete. Confirm account posting time with your payment provider.',
    '払い戻しは請求書調整の段階に進んでいます。全手続きは未完了です。着金時期は決済機関にご確認ください。',
  ],
  'ts.progress.context': [
    '退票進度 · 款項處理中',
    'Refund progress · Payment processing',
    '払い戻し状況 · 返金手続き',
  ],
  'ts.progress.waiting': ['等待處理', 'Pending', '処理待ち'],
  'ts.progress.refresh': ['重新查詢', 'Check again', '再照会'],
  'ts.progress.refreshing': [
    '正在更新退款進度…',
    'Updating refund progress…',
    '払い戻し状況を更新中…',
  ],
  'ts.progress.stale': [
    '更新失敗，以下為上次查詢資料。請重新查詢或洽櫃檯。',
    'Update failed. The previous result is shown. Try again or ask staff.',
    '更新できませんでした。前回の照会結果です。再照会するか窓口にご相談ください。',
  ],
  'ts.progress.requestedAmount': ['申請退款金額', 'Requested refund amount', '申請返金額'],
  'ts.progress.created': ['申請時間', 'Requested at', '申請日時'],
  'ts.progress.closing': [
    '退款與折讓已完成，等待系統結案。',
    'Refund and invoice adjustment are complete. Awaiting final closure.',
    '返金と請求書調整は完了しています。最終処理待ちです。',
  ],
  'ts.progress.allowanceFailed': [
    '退款已完成，但折讓處理異常。請保留申請編號並洽櫃檯，請勿重新申請。',
    'The refund is complete, but invoice adjustment failed. Keep your reference and ask staff; do not reapply.',
    '返金は完了していますが、請求書調整でエラーが発生しました。申請番号を保管し、再申請せず窓口にご相談ください。',
  ],

  'ts.qr.rescan': ['重新掃描', 'Scan again', '再スキャン'],
  'ts.qr.available': [
    '掃描原票券查詢航班或退票進度',
    'Scan your original ticket for sailing or refund details',
    '元のチケットをスキャンして便や払い戻し状況を確認できます',
  ],
  'ts.qr.hint': [
    '請將原票券 QR Code 對準掃描器，掃描後會自動顯示查詢結果。',
    'Hold your original ticket QR code in front of the scanner. Results appear automatically.',
    '元のチケットのQRコードをスキャナーにかざしてください。結果は自動で表示されます。',
  ],
  'ts.qr.reading': ['正在讀取票券', 'Reading your ticket', 'チケットを読み取っています'],
  'ts.qr.verifying': [
    '正在驗證票券，請稍候',
    'Verifying your ticket, please wait',
    'チケットを確認しています',
  ],
  'ts.qr.readOnly': [
    '此頁僅供查詢，登船報到請由現場人員協助。',
    'This page is for enquiries only. Please ask staff for boarding check-in.',
    'このページは照会専用です。乗船受付はスタッフにお申し付けください。',
  ],
  'ts.qr.next.refund': [
    '機台尚未開放正式退票，請攜帶原票券洽服務櫃檯。',
    'Refund requests are not yet available here. Bring your original ticket to the service desk.',
    'この端末では払い戻し申請はまだご利用いただけません。元のチケットを窓口へお持ちください。',
  ],
  'ts.lookup.flight': ['我的航班', 'My sailing', 'ご利用の便'],
  'ts.lookup.refund': ['退票資訊', 'Refund information', '払い戻し情報'],
  'ts.lookup.cancelledContext': [
    '航班查詢 · 停航',
    'Sailing enquiry · Cancelled',
    '便の照会 · 欠航',
  ],
  'ts.lookup.stopped': ['停航', 'Cancelled', '欠航'],
  'ts.lookup.cancelledReason': [
    '停航原因：{reason}。本班次已停航，無法依原定時間搭乘。',
    'Cancellation reason: {reason}. This sailing is cancelled and will not depart as scheduled.',
    '欠航理由：{reason}。この便は欠航のため、予定時刻にご乗船いただけません。',
  ],
  'ts.lookup.scheduledDeparture': ['原定出發', 'Scheduled departure', '出発予定'],
  'ts.lookup.cancelledNote': [
    '此航班已停航，可至「退款進度」查詢退票處理情形。',
    'This sailing is cancelled. Check Refund progress for refund details.',
    'この便は欠航です。「払い戻し状況」で手続きの状況をご確認ください。',
  ],
  'ts.lookup.context.flight': [
    '航班查詢 · 查詢結果',
    'Sailing enquiry · Results',
    '便の照会 · 照会結果',
  ],
  'ts.lookup.context.refund': [
    '退票服務 · 票券資料',
    'Refund service · Ticket details',
    '払い戻し · チケット情報',
  ],
  'ts.lookup.context.progress': [
    '退款進度 · 查詢結果',
    'Refund progress · Results',
    '払い戻し状況 · 照会結果',
  ],
  'ts.lookup.ticketState.valid': [
    '票券有效 · 尚未使用',
    'Valid ticket · Not yet used',
    '有効なチケット · 未使用',
  ],
  'ts.lookup.ticketState.used': ['票券已使用', 'Ticket already used', '使用済みのチケット'],
  'ts.lookup.ticketState.void_pending_refund': [
    '票券退票處理中',
    'Ticket refund in progress',
    'チケット払い戻し処理中',
  ],
  'ts.lookup.ticketState.voided': ['票券已作廢', 'Ticket voided', '無効なチケット'],
  'ts.lookup.ticketState.expired': ['票券已過期', 'Ticket expired', '期限切れのチケット'],
  'ts.lookup.adult': ['成人票', 'Adult ticket', '大人券'],
  'ts.lookup.unknown': ['尚未提供', 'Not provided', '情報未提供'],
  'ts.lookup.cancelled': [
    '此航班已因天候取消，請洽服務櫃檯',
    'This sailing has been cancelled due to weather. Please ask staff.',
    '天候により欠航しています。窓口へお尋ねください',
  ],
  'ts.lookup.noRefund': [
    '目前查無退票申請紀錄',
    'No refund application was found for this ticket',
    'このチケットの払い戻し申請はありません',
  ],
  'ts.lookup.refundState': ['退票申請狀態', 'Refund application status', '払い戻し申請状況'],
  'ts.lookup.updated': ['最後更新時間', 'Last updated', '最終更新日時'],
  'ts.lookup.manual': [
    '此申請需人工處理，請洽服務櫃檯確認',
    'This application needs manual review. Please ask staff.',
    'この申請は手動対応が必要です。窓口へお尋ねください',
  ],
  'ts.lookup.allowance': [
    '款項已退款，發票折讓仍待完成',
    'Payment refunded; invoice allowance is still pending',
    '返金済みです。請求書の減額処理は未完了です',
  ],
  'ts.lookup.latest': [
    '顯示此票券最新建立的退票申請。實際入帳時間請向付款機構確認。',
    'Showing the latest application for this ticket. Confirm account posting time with your payment provider.',
    'このチケットの最新の申請を表示しています。着金時期は決済機関にご確認ください。',
  ],
  'ts.lookup.method.original_payment': ['原付款方式', 'Original payment method', '元の支払方法'],
  'ts.lookup.method.manual_transfer': ['人工轉帳', 'Manual transfer', '手動振込'],
  'ts.lookup.state.requested': ['已提出申請', 'Requested', '申請済み'],
  'ts.lookup.state.refund_authorized': ['退款進行中', 'Refund in progress', '払い戻し手続き中'],
  'ts.lookup.counterRefund': [
    '原付款為刷卡，請至服務櫃檯辦理退刷。若已辦理，請由櫃檯確認結果。',
    'You paid by card. Please visit the service counter for your card refund. If already processed, ask staff to confirm the result.',
    'カードでのお支払いのため、サービスカウンターで返金手続きをしてください。手続き済みの場合は、係員に結果をご確認ください。',
  ],
  'ts.lookup.state.refund_settling': ['退款處理中', 'Refund settling', '返金処理中'],
  'ts.lookup.state.refund_settled': ['款項已退款', 'Payment refunded', '返金済み'],
  'ts.lookup.state.allowance_pending': [
    '發票折讓處理中',
    'Invoice allowance pending',
    '請求書減額処理中',
  ],
  'ts.lookup.state.allowance_issued': [
    '發票折讓已開立',
    'Invoice allowance issued',
    '請求書減額発行済み',
  ],
  'ts.lookup.state.completed': ['退票已完成', 'Refund completed', '払い戻し完了'],
  'ts.lookup.state.refund_failed': ['退款失敗', 'Refund failed', '返金失敗'],
  'ts.lookup.state.allowance_failed': [
    '發票折讓失敗',
    'Invoice allowance failed',
    '請求書減額失敗',
  ],
  'ts.lookup.state.manual_review': ['待人工處理', 'Manual review', '手動対応待ち'],
  'ts.lookup.state.cancelled': ['申請已取消', 'Application cancelled', '申請取消済み'],
  'ts.lookup.state.rejected': ['申請未核准', 'Application rejected', '申請却下'],
  'ts.qr.error.format': [
    'QR Code 內容不完整或格式不正確，請重新掃描原票券。',
    'The QR content is incomplete or malformed. Scan the original ticket again.',
    'QRの内容が不完全、または形式が正しくありません。元のチケットを再スキャンしてください。',
  ],
  'ts.qr.error.signature': [
    '無法驗證此 QR Code 的簽章，請重新掃描原票券或洽服務櫃檯。',
    'This QR signature could not be verified. Scan the original ticket again or ask staff.',
    'QRの署名を確認できません。元のチケットを再スキャンするか、窓口へお尋ねください。',
  ],
  'ts.qr.error.notFound': [
    '找不到此 QR Code 對應的票券，請確認票券或洽服務櫃檯。',
    'No ticket matches this QR code. Check your ticket or ask staff.',
    'このQRに対応するチケットが見つかりません。チケットをご確認いただくか、窓口へお尋ねください。',
  ],
  'ts.qr.error.network': [
    '目前無法連線，請重新掃描或稍後重試。這不代表票券無效。',
    'Unable to connect. Scan again or retry later. This does not mean your ticket is invalid.',
    '接続できません。再スキャンまたは後ほど再試行してください。チケットが無効という意味ではありません。',
  ],
  'ts.qr.error.timeout': [
    '驗證等待逾時，請重新掃描或重試。',
    'Verification timed out. Scan again or retry.',
    '確認がタイムアウトしました。再スキャンまたは再試行してください。',
  ],
  'ts.qr.error.unavailable': [
    '目前無法完成票券驗證，請稍後重試或洽服務櫃檯。',
    'Ticket verification is unavailable. Retry later or ask staff.',
    'チケットを確認できません。後ほど再試行するか、窓口へお尋ねください。',
  ],
  'ts.qr.error.rateLimit': [
    '查詢次數較多，請稍候再試。',
    'Too many requests. Please wait before retrying.',
    '照会回数が多いため、少し待ってから再試行してください。',
  ],
  'ts.qr.state.valid': ['有效', 'Valid', '有効'],
  'ts.qr.state.used': ['已使用', 'Used', '使用済み'],
  'ts.qr.state.void_pending_refund': ['退票處理中', 'Refund pending', '払い戻し処理中'],
  'ts.qr.state.voided': ['已作廢', 'Voided', '無効'],
  'ts.qr.state.expired': ['已過期', 'Expired', '期限切れ'],
};
